<template>
    <div>
        <h2>Profile</h2>
        <Spinner v-if="displaySpinner" />
        <TabView>
            <TabPanel header="General">
                <div class="general-section">
                    <div class="form-field">
                        <label for="fullname">Name</label>
                        <InputText
                            id="fullname"
                            type="text"
                            v-model="genForm.fullname"
                            :disabled="true"
                        />
                    </div>
                    <div class="form-field">
                        <label for="email">Email</label>
                        <InputText
                            id="email"
                            type="text"
                            v-model="genForm.email"
                            :disabled="true"
                        />
                    </div>
                    <div class="button-group">
                        <Button
                            label="Cancel"
                            class="p-button-secondary mr-2"
                            :disabled="true"
                        />
                        <Button label="Update Changes" />
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Roles">
                <div class="general-section">
                    <div class="p-field col-12">
                        <label for="role">Roles</label>
                        <br />
                        <div>{{ user?.role }}</div>
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Security">
                <Button
                    class="p-button-link"
                    label="Sign out"
                    @click="signOutUser"
                />
                <br />
                <Button
                    class="p-button-link"
                    label="Change password"
                    :disabled="true"
                />
                <br />
                <Button
                    class="p-button-link"
                    label="Configure public key"
                    :disabled="true"
                />
                <br />
                <Button
                    class="p-button-link"
                    label="Control account access"
                    :disabled="true"
                />
                <br />
                <Button
                    class="p-button-link"
                    label="Download personal data"
                    :disabled="true"
                />
                <br />
                <div class="delete-account" style="float: right">
                    <Button
                        class="p-button-danger"
                        label="Delete Account"
                        :disabled="true"
                    />
                </div>
            </TabPanel>
        </TabView>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Spinner from "@/shared/Spinner.vue";
import { useAuthenticationService } from "@/composables/authentication";
import { useUserStore, useUserManager } from "@/stores/user-store";
import { useRouter } from "vue-router";

const router = useRouter();
const { signOut } = useAuthenticationService();
const { user } = useUserManager();
const { reset: resetUser } = useUserStore();
const displaySpinner = ref(false);
const genForm = ref({
    fullname: "",
    email: "",
});

const signOutUser = async () => {
    await signOut();
    router.push({ name: "home" });
    resetUser();
};

watch(
    user,
    (newUser) => {
        if (newUser) {
            genForm.value.fullname = newUser.name;
            genForm.value.email = newUser.email;
        }
        displaySpinner.value = false;
    },
    { immediate: true }
);
</script>

<style lang="scss" scoped>
.password-reset,
.general-section,
.public-key {
    display: inline-block;
    width: 100%;
    .action-btn {
        text-align: right;
    }
}
.subtitle {
    font-style: italic;
}

.general-section .form-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 4px;
}
.general-section .button-group {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 20px;
}
</style>
